export const MONTHS = [
  {
    label: 'January',
    value: '01'
  },
  {
    label: 'February',
    value: '02'
  },
  {
    label: 'March',
    value: '03'
  },
  {
    label: 'April',
    value: '04'
  },
  {
    label: 'May',
    value: '05'
  },
  {
    label: 'June',
    value: '06'
  },
  {
    label: 'July',
    value: '07'
  },
  {
    label: 'August',
    value: '08'
  },
  {
    label: 'September',
    value: '09'
  },
  {
    label: 'October',
    value: '10'
  },
  {
    label: 'November',
    value: '11'
  },
  {
    label: 'December',
    value: '12'
  }
]

export const YEARS = [
  {
    label: 2016,
    value: 1
  },
  {
    label: 2017,
    value: 2
  },
  {
    label: 2018,
    value: 3
  },
  {
    label: 2019,
    value: 4
  },
  {
    label: 2020,
    value: 5
  },
  {
    label: 2021,
    value: 6
  },
  {
    label: 2022,
    value: 7
  },
  {
    label: 2023,
    value: 8
  },
  {
    label: 2024,
    value: 9
  },
  {
    label: 2025,
    value: 10
  }
]



// WEBPACK FOOTER //
// ./src/components/Pages/HereMapsDashboard/ConstantData.js